import { login, logout, getUserInfo } from '@/api/user' // 引入用户相关接口
import { removeToken, setToken, getToken } from '@/utils/auth' // 引入token工具类

const state = {
    token: getToken() || '', // 从本地存储读取token初始化
    userInfo: {}, // 用户信息
    roles: [] // 用户角色（用于权限控制）
}

const mutations = {
    // 设置token
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    // 设置用户信息
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo
    },
    // 设置角色
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    // 清除所有状态
    CLEAR_STATE: (state) => {
        state.token = ''
        state.userInfo = {}
        state.roles = []
    }
}

const actions = {
    /**
     * 登录操作
     * @param {Object} context - 上下文对象
     * @param {Object} userInfo - 登录信息（username, password）
     * @returns {Promise}
     */
    login({ commit }, userInfo) {
        const { username, password } = userInfo
        return new Promise((resolve, reject) => {
            // 调用登录接口
            login({ username: username, password: password })
                .then(response => {
                    if (response) {
                        console.log('登录成功', response)
                        const { token } = response.data || '' // 假设接口返回token
                        // 存储token到vuex和本地
                        commit('SET_TOKEN', token)
                        setToken(token)
                        resolve(response)
                    }

                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * 获取用户信息（登录后调用）
     * @param {Object} context - 上下文对象
     * @returns {Promise}
     */
    getUserInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            // 调用获取用户信息接口（需要token，已在request拦截器中自动添加）
            getUserInfo()
                .then(response => {
                    // 存储用户信息和角色
                    commit('SET_USER_INFO', response)
                    commit('SET_ROLES', response.user_role || '')
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * 退出登录
     * @param {Object} context - 上下文对象
     * @returns {Promise}
     */
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            // 调用后端退出接口（可选，根据实际需求）
            commit('CLEAR_STATE')
            removeToken()
            removeToken('user_id')
            resolve()
            // logout()
            //     .then(() => {
            //         // 清除token和状态
            //         commit('CLEAR_STATE')
            //         removeToken()
            //         resolve()
            //     })
            //     .catch(error => {
            //         // 即使接口失败，也强制清除本地状态
            //         commit('CLEAR_STATE')
            //         removeToken()
            //         reject(error)
            //     })
        })
    },

    /**
     * 强制清除token（如token过期时）
     * @param {Object} context - 上下文对象
     */
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('CLEAR_STATE')
            removeToken()
            resolve()
        })
    }
}

export default {
    namespaced: true, // 开启命名空间，避免模块间命名冲突
    state,
    mutations,
    actions
}